import styled from 'styled-components';
import { breakpoints } from 'themes/helpers';

export const Wrapper = styled.header`
  background: white;
  min-height: 116px;
  display: flex;

  flex-direction: column;
  justify-content: center;
  align-items: stretch;

  padding: 0;

  a {
    &:focus {
      outline-offset: -2px;
    }
  }

  @media (min-width: ${() => breakpoints.tablet}px) {
    border-bottom: 2px solid ${({ theme }) => theme.palette.neutral.base};
    min-height: 63px;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0 24px;

    a:focus {
      outline-offset: 3px;
    }
  }
`;

export const LocalePickerWrapper = styled.div`
  min-width: 185px;
  padding: 16px 11px 12px 16px; // for some reason padding-top appears smaller than the padding-bottom with the same value
  background-color: ${({ theme }) => theme.palette.neutral.base};

  @media (min-width: ${() => breakpoints.tablet}px) {
    background-color: transparent;
    padding: 0;
  }
`;
